import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Hero from "./components/Hero";
import ColumnIntro from "./components/ColumnIntro";
import ContentFeed from "./components/ContentFeed";
import EditorialShowcase from "./components/EditorialShowcase";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import ContactCta from "./components/ContactCta";
import { useSeo } from "../../hooks/useSeo";
import { faqs } from "../../mocks/articles";

export default function HomePage() {
  useSeo({
    title: "今日瓜报 - 头条解读与深度瓜分析 · 不止吃瓜更看懂门道",
    description:
      "今日瓜报专注娱乐热点深度解读，头条解读、重点瓜分析与深度报道讲透来龙去脉，编辑推荐与封面故事聚焦特别关注，满足追求深度的吃瓜需求。",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "今日瓜报",
        url: "https://ocbdo.cn/",
        description: "专注娱乐热点头条解读、重点瓜分析与深度报道的内容媒体。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://ocbdo.cn/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "今日瓜报",
        url: "https://ocbdo.cn/",
        logo: "https://ocbdo.cn/",
        description: "专注娱乐热点深度解读与深度报道的独立内容媒体。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: f.a,
          },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <ColumnIntro />
        <ContentFeed />
        <EditorialShowcase />
        <AboutSection />
        <FaqSection />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}